import Api from './api';

const slug = 'auth';
export default {
  login(credentials) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/login`, credentials)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getDemoToken(password) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/login_demo`, { password })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  register(account) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/register`, account)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  requestPasswordReset(email) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/forgot_password`, { email })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  confirmPasswordReset(token, password1, password2) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/reset_password/${token}`, { password1, password2 })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  logout() {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/logout`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  },
  checkJwt() {
    return new Promise((resolve, reject) => {
      // Scoped timeout: the auth poll must fail fast, but we keep it off the
      // shared Api instance so genuinely long requests (uploads, report/video
      // processing) are not severed.
      Api.get('/v1/users/me', { timeout: 15000 })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  checkEmail(email) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/check`, { email })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  checkGoogleCalendarConnection(userId) {
    return new Promise((resolve, reject) => {
      Api.get(`/v1/users/${userId}/google-calendar-connected`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  disconnectGoogleCalendar(userId) {
    return new Promise((resolve, reject) => {
      Api.delete(`/v1/users/${userId}/google-calendar`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getUsers({ programSlug, role }) {
    return new Promise((resolve, reject) => {
      Api.get('/v1/users', {
        params: {
          role,
          programSlug,
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getUser(id, enhancedData = false) {
    return new Promise((resolve, reject) => {
      Api.get(`/v1/users/${id}`, {
        params: {
          enhancedData,
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  saveUserProfile(user) {
    return new Promise((resolve, reject) => {
      Api.post(`/v1/users/update/${user._id}`, user)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteUserProfile(user) {
    return new Promise((resolve, reject) => {
      Api.delete(`/v1/users/${user._id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  searchUsers(query, role = null) {
    return new Promise((resolve, reject) => {
      let params = {};
      if (role) {
        params = {
          role,
        };
      }

      Api.get(`/v1/users/search/${query}`, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAvailableCoaches() {
    return new Promise((resolve, reject) => {
      let params = {
        role: {
          $in: ['Coach', 'Administrator'],
        },
        limit: 100,
      };

      Api.get(`/v1/admin-users`, { params })
        .then((res) => {
          resolve(res.data.result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  verifyEmail(userId, token) {
    return new Promise((resolve) => {
      Api.get(`/${slug}/verify/${userId}/${token}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.error(err);
          resolve(false);
        });
    });
  },
  getUserProgress(userId, programId = null) {
    return new Promise((resolve, reject) => {
      Api.get(`/v1/users/${userId}/progress`, {
        params: {
          program_id: programId,
        },
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getUserPrograms(userId) {
    return new Promise((resolve, reject) => {
      Api.get(`/v1/users/${userId}/programs`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateProgress(userId, programId = null, progress) {
    return new Promise((resolve, reject) => {
      Api.put(`/v1/users/${userId}/progress`, {
        userId,
        programId,
        ...progress,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
